import { DescriptionList } from '~/eds/src/components/DescriptionList/DescriptionList';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { UserAction } from '~/eds/src/types/UserAction';

import { ReferenceValue } from '../types/fields';
import { useDisplayQuestionValue } from '../WorkflowDisplayForm/useDisplayQuestionValue';
import { WorkflowQuestionFormField } from './types';

export const ContractTypeWorkflowQuestion = ({
  question,
  search,
}: WorkflowQuestionFormField<ReferenceValue>) => {
  const displayQuestionValue = useDisplayQuestionValue();

  const { title, description: questionDescription } = question;

  const terms: {
    title: string;
    actions?: UserAction[];
    tooltip?: string;
    description: React.ReactNode;
  }[] = [
    {
      title,
      tooltip: questionDescription ?? '',
      description: displayQuestionValue(question.field),
    },
  ];

  return (
    <Layout direction="column" spacing={2}>
      <DescriptionList terms={terms} limit={1000} search={search} />
    </Layout>
  );
};
